import type { TextProps } from '@stickerapp-org/athena/Text';
import type {
  LinkMark,
  Richtext,
  RichtextContent,
  RichtextContentWithChildContent,
  RichtextText,
  StoryLinkMark,
} from '@storyblok-types';

export function isRichTextEmpty(text: Richtext | undefined): text is undefined {
  if (!text?.content?.length) {
    return true;
  }
  return contentIsEmpty(text.content);
}

function contentIsEmpty(content: RichtextContent[] | undefined) {
  if (!content) {
    return true;
  }
  for (const child of content) {
    if (isText(child) && child.text) {
      return false;
    }
    if (isRichtextContentWithChildContent(child) && !contentIsEmpty(child.content)) {
      return false;
    }
  }
  return true;
}

export const isText = (obj: RichtextContent): obj is RichtextText => obj.type === 'text';

export const isRichtextContentWithChildContent = (
  obj: RichtextContent,
): obj is RichtextContentWithChildContent => !!(obj as RichtextContentWithChildContent).content;

export type RichTextProps = {
  size?: TextProps['size'];
  color?: TextProps['color'];
  text?: Richtext;
  class?: string;
};

export const isLinkMark = (obj: unknown): obj is LinkMark => {
  if (!obj) {
    return false;
  }
  const mark = obj as LinkMark;
  return mark.type === 'link' && !!mark.attrs;
};

export const isStoryLinkMark = (obj: unknown): obj is StoryLinkMark => {
  return isLinkMark(obj) && obj.attrs.linktype === 'story';
};

export type LinkMarkWithValidUrl = LinkMark & {
  computedUrl: string;
};

export const isLinkMarkWithValidUrl = (obj: unknown): obj is LinkMarkWithValidUrl => {
  if (!obj) {
    return false;
  }
  const mark = obj as LinkMarkWithValidUrl;
  return mark.type === 'link' && !!mark.computedUrl;
};
